import {
  MESSAGING_PARAMETER_TYPE_FETCH_REQUEST,
  MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_SUCCESS,
  MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_FAILURE,
  MESSAGING_PARAMETER_TYPE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: true,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const messagingParameterTypesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MESSAGING_PARAMETER_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case MESSAGING_PARAMETER_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MESSAGING_PARAMETER_TYPE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default messagingParameterTypesReducer;
